import { useState } from "react";

// Dasha Love holding QUANTUM CODES at sunset.
// Drop the optimized photo at: /app/frontend/public/images/dasha-quantum-codes.jpg
const PHOTO_SRC = "/images/dasha-quantum-codes.jpg";
const PHOTO_ALT =
  "Dasha Love holding the QUANTUM CODES book at sunset — Human Design & Gene Keys Playbook";

export const DashaPhoto = ({ className = "", testId = "dasha-photo" }) => {
  const [missing, setMissing] = useState(false);

  if (missing) {
    return (
      <div
        data-testid={testId}
        className={`flex flex-col items-center justify-center gap-3 border border-dashed border-lime/50 bg-ink/60 p-8 text-center ${className}`}
        style={{ aspectRatio: "4 / 5" }}
      >
        <span className="font-condensed text-sm uppercase tracking-[0.35em] text-lime">
          Dasha Love
        </span>
        <span className="font-serif-accent text-2xl italic text-cream">Quantum Codes</span>
        <span className="max-w-[220px] text-xs leading-relaxed text-cream/50">
          Photo slot reserved — the uploaded sunset photograph displays here.
        </span>
      </div>
    );
  }

  return (
    <img
      data-testid={testId}
      src={PHOTO_SRC}
      alt={PHOTO_ALT}
      loading="lazy"
      onError={() => setMissing(true)}
      className={`object-cover ${className}`}
    />
  );
};
